import React, { useState } from "react";
import styled from "styled-components";

const yearLabels = {
  1: "First",
  2: "Second",
  3: "Third",
  4: "Fourth",
  5: "Fifth",
  6: "Sixth",
  7: "Seventh",
  8: "Eighth",
  9: "Ninth"
};

function convertYearText(year) {
  const yearNumber = parseInt(year);
  const label = yearLabels[yearNumber] || year;
  return `${label} Year Modules`;
}

// Styled Components
const YearGroup = styled.div`
  margin-bottom: 10px;
    box-shadow: 0px 2px 2.97px 0.03px var(--boxShadow);
`;

const YearAccordionHeader = styled.div`
  background-color: var(--topbar-color);
  border-radius: ${props => props.$collapsed ? "2px" : "2px 2px 0 0"};
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  height: 40px;
  box-sizing: border-box;

  &:hover {
    background-color: var(--button-hover-color);
  }
  @media (max-width: 768px) {
    height: auto;
    min-height: 48px;
    flex-wrap: nowrap;
    gap: 5px; 
    display: flex;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  @media (max-width: 480px) {
    padding: 12px;
  }
`;

const YearAccordionTitle = styled.span`
  color: var(--white);
  font-size: 14px;
  font-weight: bold;
   @media (max-width: 768px) {font-size:12px}
`;

const YearAccordionRight = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  color: var(--white);
  font-size: 14px;
 
  @media (max-width: 768px) {
    flex-wrap: nowrap;

  }
`;

const CompletedText = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const getLeftBorderColor = (status, isOptionalDeregister) => {
  const statusLower = (status || "").toLowerCase();
  if (statusLower === "fail" || statusLower === "failed") return "var(--red)";
  if (statusLower === "eligible") return "var(--info)";
  if (statusLower === "deregister") {
    return isOptionalDeregister ? "var(--yellow)" : "var(--purple)";
  }
  if (statusLower === "pass" || statusLower === "passed" || statusLower === "exempt" || statusLower === "exempted") return "var(--green)";
  if (statusLower === "not eligible" || statusLower === "noteligible" || statusLower === "not_eligible") return "var(--warning)";
  if (statusLower === "inactive") return "var(--purple)";
  return "var(--gray)";
};

const ModuleRowContainer = styled.div`
  background-color: #fff;
  border: 1px solid #D7DEE8;

  border-top: ${props => props.$isFirst ? "1px solid #D7DEE8" : "none"};
  border-left: 5px solid ${props => getLeftBorderColor(props.$status, props.$isOptionalDeregister)};
  border-radius: ${props => props.$isLast && !props.$isExpanded ? "0 0 2px 2px" : "0"};
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 40px;
  box-sizing: border-box;
  cursor: ${props => props.$canExpand ? "pointer" : "default"};

  &:hover {
    background-color: ${props => props.$canExpand ? "#f8f9fa" : "#fff"};
  }
  @media (max-width: 1024px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
    padding: 12px;
    min-height: 48px;
  }
  @media (max-width: 480px) {
    gap: 10px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
`;

const ModuleLeft = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    row-gap: 2px;
    align-items: flex-start;
  }
`;

const ModuleIcon = styled.div`
  width: 18px;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
`;

const ModuleName = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: var(--link-color);
    text-box-edge: cap alphabetic;
text-box-trim: trim-both;
  font-family: "Segoe UI";
  line-height: normal;
  word-break: break-word;
`;

const ModuleCode = styled.span`
color: #A0A0A0;
 font-size: 12px;
   font-family: "Segoe UI";
  text-box-edge: cap alphabetic;
text-box-trim: trim-both;
`;

const ModuleRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 250px;
  justify-content: space-between;
  @media (max-width: 1024px) {
    width: 100%;
    flex-wrap: wrap;
    row-gap: 2px;
  }
  @media (max-width: 768px) {
    justify-content: space-between;
  }
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  @media (max-width: 320px) {
    gap: 6px;
  }
`;

const ModuleSemester = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
    text-box-edge: cap alphabetic;
text-box-trim: trim-both;
  color: var(--lightGray3);
  line-height: 1.25;
  word-break: break-word;
`;

const StatusWrapper = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  @media (max-width: 768px) {
    justify-content: flex-start;
    flex-wrap: wrap;
    row-gap: 6px;
  }
`;

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: fit-content;
  padding: 3px 5px;
  width: fit-content;
  border-radius: 2px;
  overflow: hidden;
  font-family: "Segoe UI", sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: bold;
  line-height: 11px;
  text-transform: uppercase;
  margin: 0;
  white-space: nowrap;

  text-align: center;
  color: var(--white);
  
  ${props => {
    const statusLower = (props.$status || "").toLowerCase();
    if (statusLower === "pass" || statusLower === "passed" || statusLower === "exempt" || statusLower === "exempted") {
      return `background-color: #5cb85c;`;
    }
    if (statusLower === "fail" || statusLower === "failed") {
      return `background-color: #d9534f;`;
    }
    if (statusLower === "not eligible" || statusLower === "noteligible" || statusLower === "not_eligible") {
      return `background-color: #ffab00;`;
    }
    if (statusLower === "eligible") {
      return `background-color: #00acc1;`;
    }
    if (statusLower === "enrolled") {
      return `background-color: #467fcf;`;
    }
    if (statusLower === "deregister") {
      return `background-color: #ffab00;`;
    }
    if (statusLower === "in progress") {
      return `background-color: #f0ad4e;`;
    }
    if (statusLower === "inactive") {
      return `background-color: var(--purple);`;
    }
    return `background-color: #6c757d;`;
  }}
`;

const ChevronIcon = styled.i`
  font-size: 20px;
  color: var(--button-color);
  width: 20px;
  text-align: center;
`;

const PrerequisitesSection = styled.div`
  background-color: #fff;
  border: 1px solid #D7DEE8;
  border-top: none;
  padding: 12px 12px 0;
  @media (max-width: 480px) {
    padding: 12px 10px 0;
  }
`;

const PrerequisitesTitle = styled.div`
  margin-bottom: 5px;
  font-size: 12px;
    line-height: 1;
    font-weight: bold;
    color: var(--black1);
 
`;

const PrerequisitesContainer = styled.div`
  border: 1px solid #D7DEE8;
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 12px;
`;

const PrerequisitesHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 12px;
  background-color: var(--sidebar-color);
  color: var(--white);
  font-size: 12px;
  font-weight: 600;
  min-height: 30px;
  width: 100%;
  box-sizing: border-box;
  border-left: 5px solid transparent;
  @media (max-width: 768px) {
    flex-wrap: wrap;
    row-gap: 6px;
    padding: 8px 12px;
  }
`;

const PrerequisitesHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

const PrerequisitesHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
    width: 238px;
    justify-content: space-between;
  @media (max-width: 768px) {
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
`;

const TableHText = styled.span`
color: var(--white);
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
    text-box-edge: cap alphabetic;
text-box-trim: trim-both;
  &:last-child {
    
    padding-right: 12px;
  }
`;

const PrerequisiteRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background-color: ${props => props.$isFailed ? "#fff8f8" : "#faf8ff"};
  border-bottom: ${props => props.$isLast ? "none" : "1px solid #D7DEE8"};
  border-left: 5px solid ${props => getLeftBorderColor(props.$status)};
  min-height: 40px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  @media (max-width: 480px) {
    gap: 10px;
  }
`;

const PrerequisiteLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  @media (max-width: 768px) {
    flex-wrap: wrap;
    row-gap: 6px;
    align-items: flex-start;
  }
`;

const PrerequisiteRight = styled.div`
  display: flex;
  justify-content: space-between;

  width:238px;
  align-items: center;
  gap: 16px;
  @media (max-width: 1024px) {
    width: 100%;
    flex-wrap: wrap;
  }
  @media (max-width: 768px) {
    justify-content: space-between;
  }
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

const PMCYearAccordion = ({ year, modules, moduleButtonRender, moduleButtonClickHandler, hideCompleted, showCount, moduleType, isOverviewTab }) => {
  const [expandedModules, setExpandedModules] = useState({});
  const [isYearExpanded, setYearExpanded] = useState(false);

  const toggleYear = () => setYearExpanded(prev => !prev);

  const toggleModule = (moduleId) => {
    setExpandedModules(prev => ({
      ...prev,
      [moduleId]: !prev[moduleId]
    }));
  };

  const completedCount = modules.filter(
    (m) => m.status === "PASS" || m.status === "EXEMPTED" || m.status === "EXEMPT"
  ).length;

  const hasPrerequisites = (module) => {
    return module.pre_requisites &&
      module.pre_requisites !== "[0]" &&
      module.pre_requisites !== "[]" &&
      typeof module.pre_requisites === "object" &&
      Object.keys(module.pre_requisites).length > 0;
  };
//TODO: Confirm status labels, prev "ENROLMENT ADJUSTMENT" : "OPTIONAL DEREGISTRATION"
  const getStatusLabel = (status, module) => {
    const statusLower = (status || "").toLowerCase();
    
    // Check for inactive status - module_status is separate from status field
    if (statusLower === "inactive") {
      return "UPCOMING";
    }
    
    if (status === "DEREGISTER") {
      return module?.optional === 0 ? "NOT ELIGIBLE" : "ADJUSTMENT";
    }
    if (statusLower === "pass") return "PASSED";
    if (statusLower === "fail") return "FAILED";
    return status || "N/A";
  };

  const renderModule = (module, index, isLast) => {
    // Check for inactive status in module_status field (separate from status field)
    const moduleStatus = (module?.module_status || "").toLowerCase();    
    const effectiveStatus = moduleStatus === "inactive" 
      ? "inactive" 
      : (moduleType ? moduleType : module.status);
    const moduleId = module.id || module.module_id || module.netsuite_product_id;
    const isExpanded = expandedModules[moduleId];
    const canExpand = !moduleButtonClickHandler && hasPrerequisites(module);
    const isCore = module.type === "required" || module.type === "core" || module.type === "foundational";
    const isOptionalDeregister = effectiveStatus === "DEREGISTER" && module.optional !== 0;

    const handleClick = () => {
      if (moduleButtonClickHandler) {
        moduleButtonClickHandler(module);
      } else if (canExpand) {
        toggleModule(moduleId);
      }
    };

    return (
      <React.Fragment key={moduleId}>
        <ModuleRowContainer
          $isFirst={index === 0}
          $isLast={isLast}
          $isExpanded={isExpanded}
          $canExpand={canExpand || !!moduleButtonClickHandler}
          $status={effectiveStatus}
          $isOptionalDeregister={isOptionalDeregister}
          onClick={handleClick}
        >
          <ModuleLeft>
          <div style={{display: "inline-flex", alignItems: "center", gap: "5px"}}>

            <ModuleIcon>
              {isCore ? (
                <i
                  title="Core"
                  className="fa-light fa-circle-exclamation-check"
                  style={{ color: "var(--purple)" }}
                />
              ) : (
                <i
                  title="Elective"
                  className="fa-light fa-arrow-progress"
                  style={{ color: "var(--teal)"}}
                />
              )}
            </ModuleIcon>
            <ModuleName>{module.name}</ModuleName>
            </div>
            {module.Code && <ModuleCode>{module.Code}</ModuleCode>}
          </ModuleLeft>
          <ModuleRight>
            <ModuleSemester>
              <i className="fa-light fa-clock" style={{ color: "var(--button-color)" }} />
              <span>{module.term === "1, 2" ? "Year Module" : `Semester ${module.term || 1}`}</span>
            </ModuleSemester>
            <StatusWrapper>
            <StatusBadge $status={effectiveStatus}>
              {getStatusLabel(effectiveStatus, module)}
            </StatusBadge>
            {moduleButtonRender ? (
              moduleButtonRender
            ) : canExpand ? (
              <ChevronIcon className={`fa-light ${isExpanded ? "fa-chevron-up" : "fa-chevron-down"}`} />
            ) : (
              <div style={{ width: "20px" }} />
            )}
            </StatusWrapper>

          </ModuleRight>
        </ModuleRowContainer>

        {isExpanded && hasPrerequisites(module) && (
          <PrerequisitesSection>
            <PrerequisitesTitle>Prerequisites</PrerequisitesTitle>
            <PrerequisitesContainer>
              {isOverviewTab && (
                <PrerequisitesHeaderRow>
                  <PrerequisitesHeaderLeft>
                  
                    <>Module</>
                  </PrerequisitesHeaderLeft>
                  <PrerequisitesHeaderRight>
                    <TableHText>Semester</TableHText>
                    <TableHText>Result</TableHText>
                  </PrerequisitesHeaderRight>
                </PrerequisitesHeaderRow>
              )}
              {Object.entries(module.pre_requisites).map(([prereqId, prereq], prereqIdx, prereqArr) => {
                const prereqStatus = prereq.reason || prereq.status || "";
                const prereqStatusUpper = prereqStatus.toUpperCase();
                const isFailed = prereqStatusUpper === "FAIL" || prereqStatusUpper === "FAILED";
                const isPrereqLast = prereqIdx === prereqArr.length - 1;
                const isPrereqCore = prereq.type !== "elective";

                return (
                  <PrerequisiteRow key={prereqId} $isFailed={isFailed} $isLast={isPrereqLast} $status={prereqStatus}>
                    <PrerequisiteLeft>
                      <ModuleIcon>
                        {isPrereqCore ? (
                          <i
                            title="Core"
                            className="fa-light fa-circle-exclamation-check"
                            style={{ color: "var(--purple)", fontSize: "16px" }}
                          />
                        ) : (
                          <i
                            title="Elective"
                            className="fa-light fa-arrow-progress"
                            style={{ color: "var(--teal)", fontSize: "16px" }}
                          />
                        )}
                      </ModuleIcon>
                      <ModuleName>{prereq.name}</ModuleName>
                      {prereq.code && <ModuleCode>{prereq.code}</ModuleCode>}
                    </PrerequisiteLeft>
                    <PrerequisiteRight>
                      <ModuleSemester>
                        <i className="fa-light fa-clock" style={{ color: "var(--button-color)" }} />
                        <span>{prereq.term === "1, 2" ? "Year Module" : `Semester ${prereq.term || 1}`}</span>
                      </ModuleSemester>
                    

                     
                      <StatusBadge $status={prereqStatus}>
                        {getStatusLabel(prereqStatus)}
                      </StatusBadge>
                      
                    </PrerequisiteRight>
                  </PrerequisiteRow>
                );
              })}
            </PrerequisitesContainer>
          </PrerequisitesSection>
        )}
      </React.Fragment>
    );
  };

  return (
    <YearGroup>
      <YearAccordionHeader $collapsed={!isYearExpanded} onClick={toggleYear}>
        <YearAccordionTitle>{convertYearText(year)}</YearAccordionTitle>
        <YearAccordionRight>
          {showCount && <span>{modules.length}</span>}
          {!hideCompleted && (
            <CompletedText>
              <i className="fa-light fa-check-circle" />
              <span style={{ fontWeight: 600 }}>Completed:</span>
              <span>{completedCount}/{modules.length}</span>
            </CompletedText>
          )}
          <i className={`fa-light ${isYearExpanded ? "fa-chevron-up" : "fa-chevron-down"}`} style={{ fontSize: "16px" }} />
        </YearAccordionRight>
      </YearAccordionHeader>

      {isYearExpanded && modules.map((module, idx) => {
        const isLast = idx === modules.length - 1;
        const moduleId = module.id || module.module_id || module.netsuite_product_id;
        const isModuleExpanded = expandedModules[moduleId];
        const actualIsLast = isLast && !isModuleExpanded;
        return renderModule(module, idx, actualIsLast);
      })}
    </YearGroup>
  );
};

export default PMCYearAccordion;
